import React, { useEffect, useState } from 'react';
import API from '../services/api';
import { useLanguage } from '../context/LanguageContext';
import PageHeader from '../components/PageHeader';
import DataTable from '../components/DataTable';
import Modal from '../components/Modal';
import { FormField, Input, SubmitBtn } from '../components/FormField';

export default function Subjects() {
  const { t, lang } = useLanguage();
  const [subjects, setSubjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState({ name:'', code:'' });
  const [saving, setSaving] = useState(false);

  const load = () => { setLoading(true); API.get('/subjects').then(r=>{setSubjects(r.data); setLoading(false);}); };
  useEffect(()=>{ load(); }, []);

  const handleSave = async e => {
    e.preventDefault(); setSaving(true);
    try {
      if (modal==='add') await API.post('/subjects', form);
      else await API.put(`/subjects/${form.id}`, form);
      setModal(null); load();
    } finally { setSaving(false); }
  };

  const subjectLabel = (name) => lang === 'en' ? t('subjectNames.' + name, name) : name;

  const columns = [
    { header: '#', render: (_, i) => i+1, width:'40px' },
    { header: t('subjects.fieldName'), render: r => subjectLabel(r.name) },
    { header: t('subjects.fieldCode'), render: r => r.code || '—' },
    { header: t('common.actions'), render: r => (
      <div style={{ display:'flex', gap:6 }}>
        <button className="btn btn-sm btn-secondary" onClick={()=>{setForm(r); setModal('edit');}} title={t('common.edit')}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 20h9"/><path d="M16.5 3.5a2.1 2.1 0 013 3L7 19l-4 1 1-4L16.5 3.5z"/></svg>
        </button>
        <button className="btn btn-sm btn-danger" onClick={async()=>{if(window.confirm(t('common.deleteConfirm'))){ try { await API.delete(`/subjects/${r.id}`); load(); } catch(err){ alert(err.response?.data?.message || 'Delete failed'); } }}} title={t('common.delete')}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3,6 5,6 21,6"/><path d="M19 6l-2 14a2 2 0 01-2 2H9a2 2 0 01-2-2L5 6"/><path d="M10 11v6M14 11v6"/></svg>
        </button>
      </div>
    )}
  ];

  return (
    <div>
      <PageHeader icon="subjects" title={t('subjects.title')} subtitle={`${t('common.total')} ${subjects.length} ${t('subjects.countSuffix')}`}
        action={<button className="btn btn-primary" onClick={()=>{setForm({name:'',code:''}); setModal('add');}}>{t('subjects.btnAdd')}</button>} />
      <DataTable columns={columns} data={subjects} loading={loading} />

      {modal && (
        <Modal title={modal==='add'?t('subjects.modalNew'):t('subjects.modalEdit')} onClose={()=>setModal(null)} size="sm">
          <form onSubmit={handleSave}>
            <FormField label={t('subjects.fieldName')} required><Input value={form.name} onChange={e=>setForm(p=>({...p,name:e.target.value}))} required /></FormField>
            <FormField label={t('subjects.fieldCode')}><Input value={form.code} onChange={e=>setForm(p=>({...p,code:e.target.value}))} placeholder={t('subjects.codePlaceholder')} /></FormField>
            <div className="form-actions">
              <button type="button" className="btn btn-secondary" onClick={()=>setModal(null)}>{t('common.cancel')}</button>
              <SubmitBtn loading={saving}>{modal==='add'?t('common.add'):t('common.save')}</SubmitBtn>
            </div>
          </form>
        </Modal>
      )}
    </div>
  );
}
